import { render, staticRenderFns } from "./BaseSelectmenu.vue?vue&type=template&id=3b5faa24&"
import script from "./BaseSelectmenu.vue?vue&type=script&lang=js&"
export * from "./BaseSelectmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports